module.exports = __webpack_public_path__ + "img/SV.5d042f89.svg";